<template>
  <div class="living-travel">
    <nav-bar show-home left-text :title="title"></nav-bar>
    <!-- banenr列表 -->
    <banner-list :banners="bannerList"></banner-list>
    <supplier-brand :brands="brands" />
    <div class="living-travel-wrapper">
      <div class="title">{{columnTit}}</div>
      <div class="living-travel-product" v-show="productList.length">
        <list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <product-list :sku-list="productList" />
        </list>
      </div>
      <div class="no-data" v-show="noData && !productList.length">
        <p>暂无商品</p>
      </div>
    </div>
  </div>
</template>

<script>
import { List } from 'vant'
import NavBar from '../../components/NavBar'
import BannerList from '../../components/RightsMall/BannerList'
import SupplierBrand from '../../components/RightsMall/SupplierBrand'
import ProductList from '../../components/RightsMall/SafeSkuList'
import api from '../../utils/api'
let flag = false
export default {
  name: 'insuranceInteres',
  components: {
    NavBar,
    BannerList,
    SupplierBrand,
    List,
    ProductList
  },
  data () {
    return {
      cid: 0,
      componentId: null,
      loading: false,
      finished: false,
      pageNum: 1,
      totalCont: 0,
      bannerList: [],
      productList: [],
      brands: [],
      columnTit: '',
      noData: false
    }
  },
  computed: {
    title () {
      return this.$route.query.title
    }
  },
  created () {
    this.$toast.loading({
      message: '正在加载...',
      dutation: 30000
    })
    this.getBannerList()
    this.getbrands()
    this.getProductColumn()
  },
  methods: {
    /**
     * 分页加载
     */
    onLoad () {
      if (flag) {
        return
      }
      flag = true
      setTimeout(() => {
        this.getProductList(++this.pageNum).then(() => {
          this.loading = false
          flag = false
        })
      }, 1000)
    },
    async getBannerList () {
      const data = await api.getLocationCodingHandler('insuranceintereshome-1')
      if (data) {
        this.bannerList = data
      }
    },

    /**
     * 获取供应商品牌
     */
    async getbrands () {
      const data = await api.getLocationCodingHandler('insuranceintereshome-2')
      if (data) {
        this.brands = data
      }
    },

    /**
     * 获取商品列表栏目id
     */
    async getProductColumn () {
      const data = await api.getLocationCodingHandler('insuranceintereshome-3')
      if (data) {
        this.columnTit = data[0].configer.title
        this.cid = data[0].configer.column
        await this.getProductList()
      }
      this.$toast.clear()
    },
    /**
     * 获取商品类表
     */
    async getProductList (pageNum) {
      const res = await this.$axios.get(
        `/api/goods/channelItems/${this.cid}/${pageNum || 1}`
      )
      if (res.status === 200) {
        const { code, data, msg, count } = res.data
        if (code === 0) {
          this.totalCont = count
          this.productList = [...this.productList, ...data]
        } else if (code === 9006) {
          this.finished = true
          if (this.pageNum === 1) {
            this.noData = true
          }
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.living-travel {
  .living-travel-wrapper {
    .title {
      display: flex;
      align-items: center;
      margin: 0.3rem 0 0;
      padding-left: 0.2rem;
      font-size: @fz32;
      color: @base;
      font-weight: 700;
      height: 0.97rem;
      background-color: #fff;
    }
  }
  .living-travel-product {
    padding: 0.2rem;
  }
  .no-data {
    text-align: center;
    padding: 1rem 0;
    font-size: @fz32;
  }
}
</style>
